import fetch from "@/fetch";
// 获取零件详情信息
export const getGoodsDetail = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/inventory/select_goods_detail",
    data: params
  });
};
// 获取零件仓储信息
export const getGoodsInquriy = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/inventory/select_goods_inventory",
    data: params
  });
};
